/*
  Shopify's Online Store 2.0 renderer wraps every section in an auto-generated,
  per-instance ID like "shopify-section-template--12345__release-countdown" —
  the numeric template ID isn't stable across environments (dev theme vs. the
  published theme), only the "__<section-key>" suffix is. Plain anchor links
  like href="#release" can't resolve against that, so we intercept hash
  clicks and match by suffix instead.

  Nav menu links use "/#section-key" (not bare "#section-key") so they still
  navigate to the homepage first when clicked from any other page — so we
  match on the link's resolved .pathname/.hash rather than the raw attribute.

  Cross-page links (e.g. Homepage -> /pages/about#leadership) land with the
  hash already in the URL and no click event to intercept, so on load we also
  resolve whatever hash the page arrived with against the same suffix match.

  2026-09-01: the click handler must compare the query string as well as the
  pathname. A paginated link like "?page=2#artist-works" has the SAME pathname
  as the page you're on, so matching on pathname alone treated it as an in-page
  jump: preventDefault() killed the navigation and pushState('#artist-works')
  rewrote the URL, dropping ?page=2 entirely. Prestige's own hash handler
  (theme.js, PageTransition) already guards on both for this reason.

  Comparing .search is safe for the in-page case because .search is RESOLVED
  against the current URL: for a bare href="#release" on /x?page=2, link.search
  is "?page=2", matching window.location.search, so those still intercept.
*/
function scrollToSuffixMatch(hash) {
  if (!hash) return false;

  const exact = document.getElementById(hash);
  const target = exact || document.querySelector(`[id$="__${hash}"]`);
  if (!target) return false;

  target.scrollIntoView({ behavior: 'auto', block: 'start' });
  return true;
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link || !link.hash) return;
  if (link.pathname !== window.location.pathname) return;
  if (link.search !== window.location.search) return;

  const hash = link.hash.slice(1);
  if (scrollToSuffixMatch(hash)) {
    event.preventDefault();
    history.pushState(null, '', `#${hash}`);
  }
});

if (window.location.hash) {
  scrollToSuffixMatch(window.location.hash.slice(1));
}
